import { useState, useEffect } from 'react'

import { getAllFunnelStages } from '@user/store/salesFunnel/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetAllFunnelStagesOnMount = () => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getAllFunnelStages())

        if (mounted) {
          if (getAllFunnelStages.fulfilled.match(result)) setStatus('success')
          else setStatus('fail')
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
